// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MileageSimulatorTab_filter_dropdown__-ykkb {
  border-radius: 5px;
  border: none;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
  font-size: 13px;
  padding-top: 7px;
  padding-bottom: 7px;
  cursor: pointer;

}

.MileageSimulatorTab_container__1lQZZ {
  background-color: #f1f2fb;
  min-height: 100vh;
}

.MileageSimulatorTab_header__7vAsA {
  color: #358696;
}

.MileageSimulatorTab_vinContainer__4Td2Z {
  min-width: 300px;
}

.MileageSimulatorTab_selectContainer__3ciMK {
  width: 130px;
}

.MileageSimulatorTab_selectVin__wVHEp {
  min-width: 150px;
}

.MileageSimulatorTab_dateContainer__0pXgS {
  min-width: 280px;
}

.MileageSimulatorTab_dateInput__j\\+LMB {
  min-width: 280px;
}

.MileageSimulatorTab_calendarIcon__eSlHH {
  right: 12px;
  width: 20px;
  height: 20px;
}

.MileageSimulatorTab_applyButton__lFgMQ {
  background-color: #358696 !important;
  color: white !important;
}

.MileageSimulatorTab_clearButton__1O13L {
  background-color: transparent;
  color: #358696;
  border: 1.5px solid #358696;
  border-radius: 8px;
  padding: 6px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.MileageSimulatorTab_clearButton__1O13L:hover {
  background-color: #358696;
  color: #ffffff;
  transform: translateY(-1px);
}


.MileageSimulatorTab_date_range_selection__B6oka {
  color: #358696;
  font-weight: bold;
}

.MileageSimulatorTab_downloadBtn__GvIzm {
  color: #83a4cf;
  text-decoration: none;
  font-size: 0.875rem;
  font-family: inherit;
}

/* New styles extracted from inline styles */
.MileageSimulatorTab_tabsContainer__7bBPe {
  scrollbar-width: thin;
}

.MileageSimulatorTab_tabButton__L604M {
  background-color: transparent !important;
  border-radius: 8px;
  min-width: fit-content;
  transition: all 0.2s ease;
  cursor: pointer;
  color: inherit !important; /* preserve parent text color */
}

.MileageSimulatorTab_tabButtonActive__zVJJq {
  background-color: #358696 !important; /* force the color */
  color: #ffffff !important; /* ensure text is white */
  border-radius: 8px;
  min-width: fit-content;
  transition: all 0.2s ease;
  cursor: pointer;
}

.MileageSimulatorTab_tabIcon__i2Ao8 {
  width: 20px;
  height: 20px;
  object-fit: contain;
  font-size: 16px;
}

.MileageSimulatorTab_tabHeaderIcon__AE4PJ {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.MileageSimulatorTab_impactArrowUp__1tUvP {
  color: #28a745;
}

.MileageSimulatorTab_impactArrowDown__9PjB9 {
  color: #dc3545;
}

.MileageSimulatorTab_bulletPoint__u12dC {
  color: #28a745;
  font-size: 8px;
}

.MileageSimulatorTab_spectrumLabel__1NrQM {
  color: #358696;
}

.MileageSimulatorTab_spectrumIcon__b8Uz- {
  color: #358696;
}

.MileageSimulatorTab_slider__FQBc9 {
  background: linear-gradient(to right, #28a745 0%, #28a745 var(--slider-value), #dee2e6 var(--slider-value), #dee2e6 100%);
  height: 8px;
  border-radius: 4px;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
}

.MileageSimulatorTab_slider__FQBc9::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #28a745;
  cursor: pointer;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.MileageSimulatorTab_slider__FQBc9::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #28a745;
  cursor: pointer;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.MileageSimulatorTab_spectrumBar__3PIfW {
  height: 40px;
}

.MileageSimulatorTab_spectrumSegment__2mHYv {
  height: 30px;
  margin: 0 1px;
}

.MileageSimulatorTab_spectrumSegmentActive__Z4H42 {
  background-color: #358696;
}

.MileageSimulatorTab_spectrumSegmentInactive__c568E {
  background-color: #6c757d;
}

.MileageSimulatorTab_analyzeButton__6KB36 {
  background-color: #358696 !important;
  color: white !important;
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  line-height: 1.5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.MileageSimulatorTab_refreshButton__q0JSo {
  background-color: white !important;
  color: #358696 !important;
  border: 1px solid #358696 !important;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  line-height: 1.5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

/* Hover/Active/Focus States */
.MileageSimulatorTab_analyzeButton__6KB36:hover,
.MileageSimulatorTab_analyzeButton__6KB36:focus,
.MileageSimulatorTab_analyzeButton__6KB36:active {
  background-color: #358696 !important;
  color: white !important;
  box-shadow: none !important;
  border: none !important;
}

.MileageSimulatorTab_refreshButton__q0JSo:hover,
.MileageSimulatorTab_refreshButton__q0JSo:focus,
.MileageSimulatorTab_refreshButton__q0JSo:active {
  background-color: #f0f4fa !important;
  color: #358696 !important;
  border-color: #358696 !important;
  box-shadow: none !important;
}


.MileageSimulatorTab_speedometerValue__1KEVp {
  color: #255C6A;
}

.MileageSimulatorTab_speedometerUnit__KcTPd {
  color: #358696;
}

.MileageSimulatorTab_speedometerText__-vq5r {
  color: #4a4a4a;
}

/* Vehicle Info Section Styles */
.MileageSimulatorTab_vehicleInfoCard__5f-9Y {
  /* Add any specific card styles here if needed */
}

.MileageSimulatorTab_toggleInput__adP5j {
  width: 80px;
}

.MileageSimulatorTab_toggleContainer__ekQJl {
  background-color: #f8f9fa;
}

.MileageSimulatorTab_toggleButtonActive__mk-nx {
  background-color: #358696 !important;
  color: white !important;
}

.MileageSimulatorTab_toggleButtonInactive__FujiL {
  background-color: transparent !important;
  color: #6c757d !important;
}

.MileageSimulatorTab_helpSection__gu-fU {
  background-color: #fff8f0;
  border: 1px solid #ffeaa7;
}

.MileageSimulatorTab_shareButton__ZkzWX {
  background-color: #358696 !important;
  color: white !important;
  font-weight: bold;
  border: none !important;
}

/* stronger specificity to override Bootstrap */
.MileageSimulatorTab_btn__U48Z9.MileageSimulatorTab_shareButton__ZkzWX,
button.MileageSimulatorTab_shareButton__ZkzWX {
  background-color: #358696 !important;
}

.MileageSimulatorTab_coloredSlider__29Ree {
  position: relative;
  height: 8px;
  background: transparent;
  outline: none;
  border-radius: 4px;
  appearance: none;

}

.MileageSimulatorTab_coloredSlider__29Ree::-webkit-slider-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  background: linear-gradient(to right,
      #28a745 0%,
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
  border-radius: 4px;
}

.MileageSimulatorTab_coloredSlider__29Ree::-moz-range-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  background: linear-gradient(to right,
      #28a745 0%,
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
  border-radius: 4px;
  border: none;
}

.MileageSimulatorTab_coloredSlider__29Ree::-webkit-slider-thumb {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #28a745;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  appearance: none;
  position: relative;
  z-index: 2;
}

.MileageSimulatorTab_coloredSlider__29Ree::-moz-range-thumb {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #28a745;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  appearance: none;
}

.MileageSimulatorTab_coloredSlider__29Ree:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px rgba(0, 255, 85, 0.25);
}

.MileageSimulatorTab_coloredSlider__29Ree:focus::-moz-range-thumb {
  box-shadow: 0 0 0 3px rgba(0, 255, 85, 0.25);
}

/* Alternative approach for better browser support */
.MileageSimulatorTab_coloredSlider__29Ree::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 8px;
  background: linear-gradient(to right,
      #28a745 0%,
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
  border-radius: 4px;
  width: 100%;
  z-index: 1;
}

/* Ensure the slider thumb is above the track */
.MileageSimulatorTab_coloredSlider__29Ree::-webkit-slider-thumb {
  position: relative;
  z-index: 2;
}

/* Enhanced styling for scrollbar tabs */
.MileageSimulatorTab_coloredSlider__29Ree.MileageSimulatorTab_hasScrollbar__nKLfu::-webkit-slider-track {
  background: linear-gradient(to right,
      #dc3545 0%,
      #dc3545 var(--static-data-value),
      #28a745 var(--static-data-value),
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
}

.MileageSimulatorTab_coloredSlider__29Ree.MileageSimulatorTab_hasScrollbar__nKLfu::-moz-range-track {
  background: linear-gradient(to right,
      #dc3545 0%,
      #dc3545 var(--static-data-value),
      #28a745 var(--static-data-value),
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
}

/* Existing slider styles - keep your existing ones and add these */
.MileageSimulatorTab_slider__FQBc9 {
  position: relative;
}

.MileageSimulatorTab_benchmarkLine__7XJ\\+b {
  pointer-events: none;
}

.MileageSimulatorTab_benchmarkLabel__-0\\+Q5 {
  pointer-events: none;
  white-space: nowrap;
  color: #358696 !important;
}

.MileageSimulatorTab_staticDataLine__-q\\+UV {
  pointer-events: none;
}

.MileageSimulatorTab_staticDataLabel__xGPsj {
  pointer-events: none;
  white-space: nowrap;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .MileageSimulatorTab_coloredSlider__29Ree {
    height: 6px;
  }

  .MileageSimulatorTab_coloredSlider__29Ree::-webkit-slider-thumb {
    height: 18px;
    width: 18px;
  }

  .MileageSimulatorTab_coloredSlider__29Ree::-moz-range-thumb {
    height: 18px;
    width: 18px;
  }
}

.MileageSimulatorTab_tabButton__L604M,
.MileageSimulatorTab_tabButton__L604M:focus,
.MileageSimulatorTab_tabButton__L604M:hover,
.MileageSimulatorTab_tabButton__L604M:active {
  background-color: transparent !important;
  color: #6c757d !important;
  /* muted grey for inactive tab */
  border: none !important;
  box-shadow: none !important;
}

.MileageSimulatorTab_tabButtonActive__zVJJq,
.MileageSimulatorTab_tabButtonActive__zVJJq:focus,
.MileageSimulatorTab_tabButtonActive__zVJJq:hover,
.MileageSimulatorTab_tabButtonActive__zVJJq:active {
  background-color: #4A9DAD !important;
  color: white !important;
  border: none !important;
  box-shadow: none !important;
}

.MileageSimulatorTab_bestValueText__r97YA {
  font-size: 18px;
  font-weight: bold;
  color: #09a106;
  margin-right: 6px;
}


.MileageSimulatorTab_redColoredSlider__B1L2j {
  position: relative;
  height: 8px;
  background: transparent;
  outline: none;
  border-radius: 4px;
  appearance: none;

}

.MileageSimulatorTab_redColoredSlider__B1L2j::-webkit-slider-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  background: linear-gradient(to right,
      #28a745 0%,
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
  border-radius: 4px;
}

.MileageSimulatorTab_redColoredSlider__B1L2j::-moz-range-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  background: linear-gradient(to right,
      #28a745 0%,
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
  border-radius: 4px;
  border: none;
}

.MileageSimulatorTab_redColoredSlider__B1L2j::-webkit-slider-thumb {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #358696;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  appearance: none;
  position: relative;
  z-index: 2;
}

.MileageSimulatorTab_redColoredSlider__B1L2j::-moz-range-thumb {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #28a745;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  appearance: none;
}

.MileageSimulatorTab_redColoredSlider__B1L2j:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

.MileageSimulatorTab_redColoredSlider__B1L2j:focus::-moz-range-thumb {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

/* Alternative approach for better browser support */
.MileageSimulatorTab_redColoredSlider__B1L2j::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 8px;
  background: linear-gradient(to right,
      #c80202 0%,
      #c80202 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
  border-radius: 4px;
  width: 100%;
  z-index: 1;
}

/* Ensure the slider thumb is above the track */
.MileageSimulatorTab_redColoredSlider__B1L2j::-webkit-slider-thumb {
  position: relative;
  z-index: 2;
}

/* Enhanced styling for scrollbar tabs */
.MileageSimulatorTab_redColoredSlider__B1L2j.MileageSimulatorTab_hasScrollbar__nKLfu::-webkit-slider-track {
  background: linear-gradient(to right,
      #dc3545 0%,
      #dc3545 var(--static-data-value),
      #28a745 var(--static-data-value),
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
}

.MileageSimulatorTab_redColoredSlider__B1L2j.MileageSimulatorTab_hasScrollbar__nKLfu::-moz-range-track {
  background: linear-gradient(to right,
      #dc3545 0%,
      #dc3545 var(--static-data-value),
      #28a745 var(--static-data-value),
      #28a745 var(--default-value),
      #28a745 var(--default-value),
      #28a745 var(--slider-value),
      #e9efec var(--slider-value),
      #e9efec 100%);
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/MileageSimulatorTab/MileageSimulatorTab.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;;AAGA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,oCAAoC,EAAE,oBAAoB;EAC1D,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yHAAyH;EACzH,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;;;EAGE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;AAC7B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAElB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf;;;;;;mBAMiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf;;;;;;mBAMiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EAExC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EAExC,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;;;;;mBAMiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE;;;;;;;;mBAQiB;AACnB;;AAEA;EACE;;;;;;;;mBAQiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;;;;EAIE,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;EAIE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAElB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf;;;;;;mBAMiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf;;;;;;mBAMiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EAExC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EAExC,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;;;;;mBAMiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE;;;;;;;;mBAQiB;AACnB;;AAEA;EACE;;;;;;;;mBAQiB;AACnB","sourcesContent":[".filter_dropdown {\n  border-radius: 5px;\n  border: none;\n  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n  font-size: 13px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  cursor: pointer;\n\n}\n\n.container {\n  background-color: #f1f2fb;\n  min-height: 100vh;\n}\n\n.header {\n  color: #358696;\n}\n\n.vinContainer {\n  min-width: 300px;\n}\n\n.selectContainer {\n  width: 130px;\n}\n\n.selectVin {\n  min-width: 150px;\n}\n\n.dateContainer {\n  min-width: 280px;\n}\n\n.dateInput {\n  min-width: 280px;\n}\n\n.calendarIcon {\n  right: 12px;\n  width: 20px;\n  height: 20px;\n}\n\n.applyButton {\n  background-color: #358696 !important;\n  color: white !important;\n}\n\n.clearButton {\n  background-color: transparent;\n  color: #358696;\n  border: 1.5px solid #358696;\n  border-radius: 8px;\n  padding: 6px 16px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.clearButton:hover {\n  background-color: #358696;\n  color: #ffffff;\n  transform: translateY(-1px);\n}\n\n\n.date_range_selection {\n  color: #358696;\n  font-weight: bold;\n}\n\n.downloadBtn {\n  color: #83a4cf;\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-family: inherit;\n}\n\n/* New styles extracted from inline styles */\n.tabsContainer {\n  scrollbar-width: thin;\n}\n\n.tabButton {\n  background-color: transparent !important;\n  border-radius: 8px;\n  min-width: fit-content;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  color: inherit !important; /* preserve parent text color */\n}\n\n.tabButtonActive {\n  background-color: #358696 !important; /* force the color */\n  color: #ffffff !important; /* ensure text is white */\n  border-radius: 8px;\n  min-width: fit-content;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.tabIcon {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  font-size: 16px;\n}\n\n.tabHeaderIcon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.impactArrowUp {\n  color: #28a745;\n}\n\n.impactArrowDown {\n  color: #dc3545;\n}\n\n.bulletPoint {\n  color: #28a745;\n  font-size: 8px;\n}\n\n.spectrumLabel {\n  color: #358696;\n}\n\n.spectrumIcon {\n  color: #358696;\n}\n\n.slider {\n  background: linear-gradient(to right, #28a745 0%, #28a745 var(--slider-value), #dee2e6 var(--slider-value), #dee2e6 100%);\n  height: 8px;\n  border-radius: 4px;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #28a745;\n  cursor: pointer;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #28a745;\n  cursor: pointer;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.spectrumBar {\n  height: 40px;\n}\n\n.spectrumSegment {\n  height: 30px;\n  margin: 0 1px;\n}\n\n.spectrumSegmentActive {\n  background-color: #358696;\n}\n\n.spectrumSegmentInactive {\n  background-color: #6c757d;\n}\n\n.analyzeButton {\n  background-color: #358696 !important;\n  color: white !important;\n  border: none;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  line-height: 1.5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.refreshButton {\n  background-color: white !important;\n  color: #358696 !important;\n  border: 1px solid #358696 !important;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  line-height: 1.5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n/* Hover/Active/Focus States */\n.analyzeButton:hover,\n.analyzeButton:focus,\n.analyzeButton:active {\n  background-color: #358696 !important;\n  color: white !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.refreshButton:hover,\n.refreshButton:focus,\n.refreshButton:active {\n  background-color: #f0f4fa !important;\n  color: #358696 !important;\n  border-color: #358696 !important;\n  box-shadow: none !important;\n}\n\n\n.speedometerValue {\n  color: #255C6A;\n}\n\n.speedometerUnit {\n  color: #358696;\n}\n\n.speedometerText {\n  color: #4a4a4a;\n}\n\n/* Vehicle Info Section Styles */\n.vehicleInfoCard {\n  /* Add any specific card styles here if needed */\n}\n\n.toggleInput {\n  width: 80px;\n}\n\n.toggleContainer {\n  background-color: #f8f9fa;\n}\n\n.toggleButtonActive {\n  background-color: #358696 !important;\n  color: white !important;\n}\n\n.toggleButtonInactive {\n  background-color: transparent !important;\n  color: #6c757d !important;\n}\n\n.helpSection {\n  background-color: #fff8f0;\n  border: 1px solid #ffeaa7;\n}\n\n.shareButton {\n  background-color: #358696 !important;\n  color: white !important;\n  font-weight: bold;\n  border: none !important;\n}\n\n/* stronger specificity to override Bootstrap */\n.btn.shareButton,\nbutton.shareButton {\n  background-color: #358696 !important;\n}\n\n.coloredSlider {\n  position: relative;\n  height: 8px;\n  background: transparent;\n  outline: none;\n  border-radius: 4px;\n  -webkit-appearance: none;\n  appearance: none;\n\n}\n\n.coloredSlider::-webkit-slider-track {\n  width: 100%;\n  height: 8px;\n  cursor: pointer;\n  background: linear-gradient(to right,\n      #28a745 0%,\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n  border-radius: 4px;\n}\n\n.coloredSlider::-moz-range-track {\n  width: 100%;\n  height: 8px;\n  cursor: pointer;\n  background: linear-gradient(to right,\n      #28a745 0%,\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n  border-radius: 4px;\n  border: none;\n}\n\n.coloredSlider::-webkit-slider-thumb {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background: #28a745;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  -webkit-appearance: none;\n  appearance: none;\n  position: relative;\n  z-index: 2;\n}\n\n.coloredSlider::-moz-range-thumb {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background: #28a745;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.coloredSlider:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 3px rgba(0, 255, 85, 0.25);\n}\n\n.coloredSlider:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 3px rgba(0, 255, 85, 0.25);\n}\n\n/* Alternative approach for better browser support */\n.coloredSlider::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 8px;\n  background: linear-gradient(to right,\n      #28a745 0%,\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n  border-radius: 4px;\n  width: 100%;\n  z-index: 1;\n}\n\n/* Ensure the slider thumb is above the track */\n.coloredSlider::-webkit-slider-thumb {\n  position: relative;\n  z-index: 2;\n}\n\n/* Enhanced styling for scrollbar tabs */\n.coloredSlider.hasScrollbar::-webkit-slider-track {\n  background: linear-gradient(to right,\n      #dc3545 0%,\n      #dc3545 var(--static-data-value),\n      #28a745 var(--static-data-value),\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n}\n\n.coloredSlider.hasScrollbar::-moz-range-track {\n  background: linear-gradient(to right,\n      #dc3545 0%,\n      #dc3545 var(--static-data-value),\n      #28a745 var(--static-data-value),\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n}\n\n/* Existing slider styles - keep your existing ones and add these */\n.slider {\n  position: relative;\n}\n\n.benchmarkLine {\n  pointer-events: none;\n}\n\n.benchmarkLabel {\n  pointer-events: none;\n  white-space: nowrap;\n  color: #358696 !important;\n}\n\n.staticDataLine {\n  pointer-events: none;\n}\n\n.staticDataLabel {\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .coloredSlider {\n    height: 6px;\n  }\n\n  .coloredSlider::-webkit-slider-thumb {\n    height: 18px;\n    width: 18px;\n  }\n\n  .coloredSlider::-moz-range-thumb {\n    height: 18px;\n    width: 18px;\n  }\n}\n\n.tabButton,\n.tabButton:focus,\n.tabButton:hover,\n.tabButton:active {\n  background-color: transparent !important;\n  color: #6c757d !important;\n  /* muted grey for inactive tab */\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.tabButtonActive,\n.tabButtonActive:focus,\n.tabButtonActive:hover,\n.tabButtonActive:active {\n  background-color: #4A9DAD !important;\n  color: white !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.bestValueText {\n  font-size: 18px;\n  font-weight: bold;\n  color: #09a106;\n  margin-right: 6px;\n}\n\n\n.redColoredSlider {\n  position: relative;\n  height: 8px;\n  background: transparent;\n  outline: none;\n  border-radius: 4px;\n  -webkit-appearance: none;\n  appearance: none;\n\n}\n\n.redColoredSlider::-webkit-slider-track {\n  width: 100%;\n  height: 8px;\n  cursor: pointer;\n  background: linear-gradient(to right,\n      #28a745 0%,\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n  border-radius: 4px;\n}\n\n.redColoredSlider::-moz-range-track {\n  width: 100%;\n  height: 8px;\n  cursor: pointer;\n  background: linear-gradient(to right,\n      #28a745 0%,\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n  border-radius: 4px;\n  border: none;\n}\n\n.redColoredSlider::-webkit-slider-thumb {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background: #358696;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  -webkit-appearance: none;\n  appearance: none;\n  position: relative;\n  z-index: 2;\n}\n\n.redColoredSlider::-moz-range-thumb {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background: #28a745;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.redColoredSlider:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n}\n\n.redColoredSlider:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n}\n\n/* Alternative approach for better browser support */\n.redColoredSlider::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 8px;\n  background: linear-gradient(to right,\n      #c80202 0%,\n      #c80202 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n  border-radius: 4px;\n  width: 100%;\n  z-index: 1;\n}\n\n/* Ensure the slider thumb is above the track */\n.redColoredSlider::-webkit-slider-thumb {\n  position: relative;\n  z-index: 2;\n}\n\n/* Enhanced styling for scrollbar tabs */\n.redColoredSlider.hasScrollbar::-webkit-slider-track {\n  background: linear-gradient(to right,\n      #dc3545 0%,\n      #dc3545 var(--static-data-value),\n      #28a745 var(--static-data-value),\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n}\n\n.redColoredSlider.hasScrollbar::-moz-range-track {\n  background: linear-gradient(to right,\n      #dc3545 0%,\n      #dc3545 var(--static-data-value),\n      #28a745 var(--static-data-value),\n      #28a745 var(--default-value),\n      #28a745 var(--default-value),\n      #28a745 var(--slider-value),\n      #e9efec var(--slider-value),\n      #e9efec 100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter_dropdown": `MileageSimulatorTab_filter_dropdown__-ykkb`,
	"container": `MileageSimulatorTab_container__1lQZZ`,
	"header": `MileageSimulatorTab_header__7vAsA`,
	"vinContainer": `MileageSimulatorTab_vinContainer__4Td2Z`,
	"selectContainer": `MileageSimulatorTab_selectContainer__3ciMK`,
	"selectVin": `MileageSimulatorTab_selectVin__wVHEp`,
	"dateContainer": `MileageSimulatorTab_dateContainer__0pXgS`,
	"dateInput": `MileageSimulatorTab_dateInput__j+LMB`,
	"calendarIcon": `MileageSimulatorTab_calendarIcon__eSlHH`,
	"applyButton": `MileageSimulatorTab_applyButton__lFgMQ`,
	"clearButton": `MileageSimulatorTab_clearButton__1O13L`,
	"date_range_selection": `MileageSimulatorTab_date_range_selection__B6oka`,
	"downloadBtn": `MileageSimulatorTab_downloadBtn__GvIzm`,
	"tabsContainer": `MileageSimulatorTab_tabsContainer__7bBPe`,
	"tabButton": `MileageSimulatorTab_tabButton__L604M`,
	"tabButtonActive": `MileageSimulatorTab_tabButtonActive__zVJJq`,
	"tabIcon": `MileageSimulatorTab_tabIcon__i2Ao8`,
	"tabHeaderIcon": `MileageSimulatorTab_tabHeaderIcon__AE4PJ`,
	"impactArrowUp": `MileageSimulatorTab_impactArrowUp__1tUvP`,
	"impactArrowDown": `MileageSimulatorTab_impactArrowDown__9PjB9`,
	"bulletPoint": `MileageSimulatorTab_bulletPoint__u12dC`,
	"spectrumLabel": `MileageSimulatorTab_spectrumLabel__1NrQM`,
	"spectrumIcon": `MileageSimulatorTab_spectrumIcon__b8Uz-`,
	"slider": `MileageSimulatorTab_slider__FQBc9`,
	"spectrumBar": `MileageSimulatorTab_spectrumBar__3PIfW`,
	"spectrumSegment": `MileageSimulatorTab_spectrumSegment__2mHYv`,
	"spectrumSegmentActive": `MileageSimulatorTab_spectrumSegmentActive__Z4H42`,
	"spectrumSegmentInactive": `MileageSimulatorTab_spectrumSegmentInactive__c568E`,
	"analyzeButton": `MileageSimulatorTab_analyzeButton__6KB36`,
	"refreshButton": `MileageSimulatorTab_refreshButton__q0JSo`,
	"speedometerValue": `MileageSimulatorTab_speedometerValue__1KEVp`,
	"speedometerUnit": `MileageSimulatorTab_speedometerUnit__KcTPd`,
	"speedometerText": `MileageSimulatorTab_speedometerText__-vq5r`,
	"vehicleInfoCard": `MileageSimulatorTab_vehicleInfoCard__5f-9Y`,
	"toggleInput": `MileageSimulatorTab_toggleInput__adP5j`,
	"toggleContainer": `MileageSimulatorTab_toggleContainer__ekQJl`,
	"toggleButtonActive": `MileageSimulatorTab_toggleButtonActive__mk-nx`,
	"toggleButtonInactive": `MileageSimulatorTab_toggleButtonInactive__FujiL`,
	"helpSection": `MileageSimulatorTab_helpSection__gu-fU`,
	"shareButton": `MileageSimulatorTab_shareButton__ZkzWX`,
	"btn": `MileageSimulatorTab_btn__U48Z9`,
	"coloredSlider": `MileageSimulatorTab_coloredSlider__29Ree`,
	"hasScrollbar": `MileageSimulatorTab_hasScrollbar__nKLfu`,
	"benchmarkLine": `MileageSimulatorTab_benchmarkLine__7XJ+b`,
	"benchmarkLabel": `MileageSimulatorTab_benchmarkLabel__-0+Q5`,
	"staticDataLine": `MileageSimulatorTab_staticDataLine__-q+UV`,
	"staticDataLabel": `MileageSimulatorTab_staticDataLabel__xGPsj`,
	"bestValueText": `MileageSimulatorTab_bestValueText__r97YA`,
	"redColoredSlider": `MileageSimulatorTab_redColoredSlider__B1L2j`
};
export default ___CSS_LOADER_EXPORT___;
